module.exports = __webpack_public_path__ + "static/img/title_3.96782ab8.jpg";